"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessage = exports.pushFreeText = void 0;
var Sentry = __importStar(require("@sentry/react"));
var date_fns_1 = require("date-fns");
var base_1 = __importStar(require("@apis/base"));
var freeText_1 = require("@domain/freeText");
var liff_1 = require("@domain/liff");
/**
 * 質問文回答送信
 *
 * @export
 * @return {*}  Promise<ErrorResponse | { status: 200 }>
 */
var pushFreeText = function (channelId, freeTextItemAnswer, setIsError) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, answers, answer, _i, answers_1, item, itemId, res, e_1;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, (0, liff_1.getUserId)()];
            case 1:
                userId = _d.sent();
                answers = freeTextItemAnswer.answers;
                _d.label = 2;
            case 2:
                _d.trys.push([2, 5, , 6]);
                answer = {};
                for (_i = 0, answers_1 = answers; _i < answers_1.length; _i++) {
                    item = answers_1[_i];
                    if (item.answer === "") {
                        continue;
                    }
                    itemId = item.id;
                    answer[itemId] = (0, freeText_1.isDate)(item.type)
                        ? (0, date_fns_1.format)(new Date(item.answer), "yyyy/MM/dd")
                        : (0, freeText_1.isDateTime)(item.type)
                            ? (0, date_fns_1.format)(new Date(item.answer), "yyyy/MM/dd HH:mm")
                            : item.answer;
                }
                return [4 /*yield*/, sendMessagesByLiff(answers)];
            case 3:
                res = _d.sent();
                if (res.status !== 200) {
                    Sentry.captureException(res);
                    setIsError(true);
                    return [2 /*return*/, (0, base_1.getSystemErrorResponse)()];
                }
                return [4 /*yield*/, base_1.default
                        .post("pushFreeText", {
                        data: {
                            scenario_id: freeTextItemAnswer.scenarioId,
                            content_id: freeTextItemAnswer.contentId,
                            answer: answer,
                            user_id: userId,
                        },
                    }, {
                        headers: { "channel-id": channelId },
                    })
                        // eslint-disable-next-line promise/always-return -- 暫定対応
                        .then(function () {
                        (0, liff_1.closeWindow)();
                    })
                        .catch(function (e) {
                        Sentry.captureException(e);
                        setIsError(true);
                    })
                        .finally(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            (0, liff_1.closeWindow)();
                            return [2 /*return*/];
                        });
                    }); })];
            case 4:
                _d.sent();
                return [2 /*return*/, {
                        status: 200,
                    }];
            case 5:
                e_1 = _d.sent();
                if ((0, base_1.isAxiosError)(e_1)) {
                    Sentry.captureException(e_1);
                    setIsError(true);
                    return [2 /*return*/, {
                            status: (_b = (_a = e_1.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 500,
                            errors: (_c = e_1.response) === null || _c === void 0 ? void 0 : _c.data.errors,
                        }];
                }
                return [3 /*break*/, 6];
            case 6:
                setIsError(true);
                return [2 /*return*/, (0, base_1.getSystemErrorResponse)()];
        }
    });
}); };
exports.pushFreeText = pushFreeText;
var sendMessagesByLiff = function (answers) { return __awaiter(void 0, void 0, void 0, function () {
    var answer, num, key, n, data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(0, liff_1.isInClient)()) return [3 /*break*/, 2];
                answer = "";
                num = 0;
                if (answers.length > 0) {
                    // eslint-disable-next-line no-restricted-syntax -- 暫定対応
                    for (key in answers) {
                        if (answers[key].answer === "") {
                            continue;
                        }
                        n = num === 0 ? "" : "\n";
                        data = (0, freeText_1.isDate)(answers[key].type)
                            ? (0, date_fns_1.format)(new Date(answers[key].answer), "yyyy/MM/dd")
                            : (0, freeText_1.isDateTime)(answers[key].type)
                                ? (0, date_fns_1.format)(new Date(answers[key].answer), "yyyy/MM/dd HH:mm")
                                : answers[key].answer;
                        answer = answer + n + answers[key].title + ":" + "\n" + data;
                        num++;
                    }
                }
                return [4 /*yield*/, (0, exports.sendMessage)(answer)];
            case 1:
                response = _a.sent();
                if (!response) {
                    return [2 /*return*/, {
                            status: 500,
                            errors: ["LIFFのメッセージ送信に失敗しました。"],
                        }];
                }
                _a.label = 2;
            case 2: return [2 /*return*/, {
                    status: 200,
                }];
        }
    });
}); };
/**
 * LIFFメッセージ送信
 *
 * @param answer
 * @return boolean
 */
var sendMessage = function (answer) { return __awaiter(void 0, void 0, void 0, function () {
    var e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, (0, liff_1.sendMessages)(answer)];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
            case 2:
                e_2 = _a.sent();
                Sentry.withScope(function (scope) {
                    scope.setTag("type", "LIFF SDK(sendMessages) does not work");
                    Sentry.captureException(e_2);
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, false];
        }
    });
}); };
exports.sendMessage = sendMessage;
